import { Injectable } from '@angular/core';
import * as amplitude from '@amplitude/analytics-browser';

import { environment } from 'environments/environment';
import { AppContextService } from './app-context.service';
import { AmplitudeUserInfo } from '@models/user';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AmplitudeService {
  private wasInit: boolean = false;
  private currentUserId: string | null = null;
  private isEnabled: boolean = false;

  constructor(private appContext: AppContextService) {}

  async init(): Promise<void> {
    if (!this.isEnabled) {
      return;
    }

    const user = await firstValueFrom(this.appContext.currentUser);

    this.currentUserId = user.user.id.toString();
    const amplitudeUser: AmplitudeUserInfo = {
      userId: user.user.id.toString(),
      companyId: user.company.id.toString(),
    };

    if (!this.wasInit && environment.production) {
      this.identifyUser(this.currentUserId, amplitudeUser);
      amplitude.init(environment.amplitude.API_KEY, {
        autocapture: false,
        minIdLength: 1,
      });
      this.wasInit = true;
      console.log('%c Amplitude initialized', 'color: #30D61F');
    } else {
      console.warn('amplitude did not init, production mode:', environment.production);
    }
  }

  private identifyUser(userId: string, userProperties?: Record<string, any>): void {
    amplitude.setUserId(userId);

    if (userProperties) {
      const identifyObj = new amplitude.Identify();
      Object.entries(userProperties).forEach(([key, value]) => {
        identifyObj.set(key, value);
      });
      amplitude.identify(identifyObj);
    }
  }

  public trackEvent(eventName: string, eventProperties?: Record<string, any>): void {
    if (!this.isEnabled) {
      return;
    }

    if (environment.production === true) {
      amplitude.track(eventName, eventProperties);
    }

    if (environment.staging) {
      console.log('%c [Amplitude]', 'color: #30D61F', eventName, eventProperties);
      // amplitude.track(eventName, eventProperties);
    }
  }
}
